export class FindingExclusion {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "FindingExclusionScope",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "FindingObjectType",
            "format": ""
        },
        {
            "name": "detector",
            "baseName": "detector",
            "type": "FindingExclusionDetectorType",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return FindingExclusion.attributeTypeMap;
    }
    constructor() {
    }
}
